import Vue from 'vue'
import VueRouter from 'vue-router'
import Feedback from '@/views/Feedback.vue'
import LogIn from '@/views/LogIn.vue'
import AllianceNews from '@/views/AllianceNews.vue'
import AppVersionSettings from '@/views/AppVersionSettings.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'LogIn',
    component: LogIn
  },
  {
    path: '/feedback',
    name: 'Feedback',
    component: Feedback
  },
  {
    path: '/news',
    name: 'AllianceNews',
    component: AllianceNews
  },
  {
    path: '/app-version',
    name: 'AppVersionSettings',
    component: AppVersionSettings
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
